module.exports = __webpack_public_path__ + "05e01fcd4beabf8b6827502aa42f63e5.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-black.woff
 ** module id = 20
 ** module chunks = 0
 **/